import Icon from "../NGMaterialIcon/NGMaterialIcon";
import { Radio, RadioGroup, Stack, Tooltip, Typography } from "@mui/material";
import { INGTextEditorProps } from "../../library/NGFieldExtensions";

export default function NGTextEditor({ selected: s }: INGTextEditorProps) {
  const handleChange = (n: { [key: string]: string }) => {
    const c = { ...s.value };
    const v = Object.keys(n);
    const a = v.map((v1) => s.value?.[v1] === n?.[v1]);
    const sa = a.some((i) => !i);

    if (sa) {
      return (s.value = { ...s.value, ...n });
    } else {
      v.forEach((v2) => {
        delete c?.[v2];
      });
    }
    s.value = c;
  };

  return (
    <Stack direction="row" flex={1} width="100%" justifyContent="space-between">
      <Stack direction="row" alignItems="center">
        <Tooltip title="Text alignment" placement="top">
          <Typography className="control-label" marginLeft="0.1rem">
            TA
          </Typography>
        </Tooltip>
        <RadioGroup
          row
          name="textAlign"
          value={s.value.textAlign ?? ""}
          className="layout-editor-radio-button"
          sx={{ width: "100%" }}
        >
          <Radio
            icon={<Icon name="format_align_left" />}
            checkedIcon={<Icon name="format_align_left" />}
            value="left"
            sx={{
              "&.MuiRadio-root.Mui-checked": {
                color: "rgba(50, 50, 50, 1)",
              },
            }}
            onClick={() => handleChange({ textAlign: "left", justifyContent: "flex-start" })}
            className="layout-editor-radio-child"
          />
          <Radio
            icon={<Icon name="format_align_center" />}
            checkedIcon={<Icon name="format_align_center" />}
            value="center"
            sx={{
              "&.MuiRadio-root.Mui-checked": {
                color: "rgba(50, 50, 50, 1)",
              },
            }}
            onClick={() => handleChange({ textAlign: "center", justifyContent: "center" })}
            className="layout-editor-radio-child"
          />
          <Radio
            icon={<Icon name="format_align_right" />}
            checkedIcon={<Icon name="format_align_right" />}
            sx={{
              "&.MuiRadio-root.Mui-checked": {
                color: "rgba(50, 50, 50, 1)",
              },
            }}
            value="right"
            onClick={() => handleChange({ textAlign: "right", justifyContent: "flex-end" })}
            className="layout-editor-radio-child"
          />
        </RadioGroup>
      </Stack>
    </Stack>
  );
}
